import { Controller } from "@hotwired/stimulus"

// Submits the form without a click. Used by the one-tap login pages so a real
// browser signs in on its own, while link scanners (which only GET) never
// consume the token.
//
// With an Altcha widget inside the form (production) the submit waits for the
// proof-of-work to verify; without one it fires after `delay` milliseconds.
export default class extends Controller {
  static values = { delay: { type: Number, default: 400 } }

  connect() {
    this.widget = this.element.querySelector("altcha-widget")

    if (this.widget) {
      this.onStateChange = (event) => {
        if (event.detail.state === "verified") this.submit()
      }
      this.widget.addEventListener("statechange", this.onStateChange)
      // The widget may have finished before this controller connected.
      if (this.widget.querySelector('input[type="hidden"]')?.value) this.submit()
    } else {
      this.timeout = setTimeout(() => this.submit(), this.delayValue)
    }
  }

  disconnect() {
    clearTimeout(this.timeout)
    this.widget?.removeEventListener("statechange", this.onStateChange)
  }

  submit() {
    if (this.submitted) return

    this.submitted = true
    this.element.requestSubmit()
  }
}
